<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<Error403 v-if="contact.status == 0" />

			<Maintenance v-else-if="contact.status == 2" />

			<div v-else-if="contact.status == 1">
				<LayoutTitle :contact="contact" />
				<LayoutForm :contact="contact" />
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutForm from "./components/LayoutForm.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Error403 from "@/components/system/Page403.vue";
import Maintenance from "@/components/system/PageMaintenance.vue";

import Meta from "@/mixins/MetaSettable";

export default {
	mixins: [Meta],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutForm,
		BaseLoading,
		Error403,
		Maintenance
	},
	data() {
		return {
			contact: [],
			pageActive: false,
			loading: true
		};
	},

	created() {
		this.axios.get("/json/contact.json").then(response => {
			this.contact = response.data.contact;
			this.loading = false;
			this.pageActive = true;
		});
	},

	mounted() {
		this.$ga.page("/contact");
	}
};
</script>

<style lang="scss">
</style>